import { render, staticRenderFns } from "./InvoiceRunLocal.vue?vue&type=template&id=b6a8da2a"
import script from "./InvoiceRunLocal.vue?vue&type=script&lang=js"
export * from "./InvoiceRunLocal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports